import { useEffect } from "react";

export function usePreventScrollOnKeyboardOpen() {
  useEffect(() => {
    // Listen to window/document scroll events to prevent iOS WKWebView window scrolling on input focus
    const handleScroll = () => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    };

    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);
}
